import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_FAVORITE_TERRITORIES_LIST: TDatadogErrorLog = {
  from: 'src/modules/global-topic/global-topic-favorite-list',
  name: 'Gets a list of favorited territories',
  message: 'Failed to fetch favorite territories',
}
